import React from "react";
import { Group } from "@mantine/core";
import { shallow } from "zustand/shallow";

import { Counter } from "@components/shared";
import useAppStore from "./location-settings-store";

export default function GeneralSettings({ onUpdate }) {
  const { settings, setSettings } = useAppStore(
    (state) => ({
      settings: state.settings,
      setSettings: state.setSettings,
    }),
    shallow
  );

  const counterFields = [
    {
      title: "Song Rating Value",
      keyName: "song_rating_value",
      value: settings.song_rating_value,
      maxValue: 7,
    },
    {
      title: "Song Rating Frequency (Days)",
      keyName: "song_rating_frequency_in_days",
      value: settings.song_rating_frequency_in_days,
    },
  ].map((m, i) => ({
    ...m,
    key: i + 1,
  }));

  return (
    <div>
      {counterFields.map((c) => (
        <Group key={c.key}>
          <Counter
            value={c.value}
            unlimited={false}
            maxValue={c.maxValue || null}
            onChange={(e) => {
              if (c.keyName === "song_rating_value") {
                if (e > 7) {
                  onUpdate({
                    [c.keyName]: 7,
                  });
                } else {
                  onUpdate({
                    [c.keyName]: e,
                  });
                }
              } else {
                onUpdate({
                  [c.keyName]: e,
                });
              }
            }}
          />
          <h3 style={{ margin: "0" }}>{c.title}</h3>
        </Group>
      ))}
    </div>
  );
}
